// extracted by mini-css-extract-plugin
export default {"closeButton":"closeButton--at9ba"};